//----------------------------------------------- CourseLayout -------------------------------------------------------------------------------------

import React from 'react';
import { CourseLayout } from '../../../components/course/CourseLayout';
import GenericCourseContainer from '../../../components/course/GenericCourseContainer';
import { courseStructure } from './course-structure';

// Importation des contenus de chapitres
import Chapitre1Content from './chapitres/Chapitre1Content';
import Chapitre2Content from './chapitres/Chapitre2Content';
import Chapitre3Content from './chapitres/Chapitre3Content';
import Chapitre4Content from './chapitres/Chapitre4Content';
import Chapitre5Content from './chapitres/Chapitre5Content';
import Chapitre6Content from './chapitres/Chapitre6Content';
import Chapitre7Content from './chapitres/Chapitre7Content';
import Chapitre8Content from './chapitres/Chapitre8Content';
import Chapitre9Content from './chapitres/Chapitre9Content';

// Mappings des composants de contenu par ID de chapitre
const chapterContents = {
  'chapitre1': Chapitre1Content,
  'chapitre2': Chapitre2Content,
  'chapitre3': Chapitre3Content,
  'chapitre4': Chapitre4Content,
  'chapitre5': Chapitre5Content,
  'chapitre6': Chapitre6Content,
  'chapitre7': Chapitre7Content,
  'chapitre8': Chapitre8Content,
  'chapitre9': Chapitre9Content,
};

const CourseContainer = () => {
  return (
    <GenericCourseContainer
      courseStructure={courseStructure}
      chapterContents={chapterContents}
      LayoutComponent={CourseLayout}
    />
  );
};

export default CourseContainer; 


